import { ReimbursementsDocs } from './reimbursementsDocs.model';

export class Reimbursements{
  constructor(
    public id?: number,
    public createdBy?: string,
    public createdDt?: any,
    public lastModifiedBy?: string,
    public lastModifiedDt?: any,
    public vendorName?: string,
    public reasonCd?: string,
    public  submittedDt?: any,
    public requestedAmount?: any,
    public  requestedDt?: any,
    public  authorizedDt?: any,
    public authorizedAmount?: any,
    public decisionCd?: string,
    public personId?: number,
    public payeeFirstName?: string,
    public payeeLastName?: string,
    public payeeVendorNumber?: string,
    public payeeSsnTin?: string,
    public payeeAddress?: string,
    public payeeCity?: string,
    public payeeState?: string,
    public payeeZip?: string,
    public costCenter?: string,
    public internalOrder?: string,
    public generalLedgerCode?: string,
    public wbs?: string,
    public otherReason?: string,
    public returnForRevisionReason?: string,
    public status?: string,
    public processStartSw?: string,
    public businessArea?: string,
    public reimbursementsDocsId?:ReimbursementsDocs[]  
  ){
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/reimbursements.model.ts